import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
    return await axios.get(url, { params }).then(res => res.data.data)
}

const useBranchesByUser = (params) => {
    var title = '/branch/by'
    if (params.is_super === true) {
        title = '/branch?paginate=false'
    } else {
        params.is_super = undefined
    }

    const { data, error, mutate } = useSWR([`${process.env.REACT_APP_GENERIC_API_URL}${title}`, params], fetcher)

    return {
        data,
        isLoading: !error && !data,
        error,
        mutate
    }
}

export default useBranchesByUser